import React from "react";
import { confirmAlert } from "react-confirm-alert";

let dialogIdCounter = 0;

export function confirmDialogA11y({ title, buttons }) {
  const dialogId = `confirm-dialog-${++dialogIdCounter}-title`;
  const previouslyFocusedElement = document.activeElement;

  const focusInitial = (node) => {
    if (!node) return;
    const buttonsList = node.querySelectorAll("button");
    if (buttonsList.length > 0) buttonsList[0].focus();
  };

  const restoreFocus = () => {
    if (previouslyFocusedElement && typeof previouslyFocusedElement.focus === "function") {
      previouslyFocusedElement.focus();
    }
  };

  const handleKeyDown = (e) => {
    if (e.key !== "Tab") return;
    const focusable = e.currentTarget.querySelectorAll("button");
    if (focusable.length === 0) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  confirmAlert({
    closeOnEscape: true,
    closeOnClickOutside: true,
    afterClose: restoreFocus,
    customUI: ({ onClose }) => (
      <div
        role="alertdialog"
        aria-modal="true"
        aria-labelledby={dialogId}
        className="react-confirm-alert-body"
        ref={focusInitial}
        onKeyDown={handleKeyDown}
      >
        <h1 id={dialogId}>{title}</h1>
        <div className="react-confirm-alert-button-group">
          {buttons.map((button, i) => (
            <button
              key={i}
              type="button"
              onClick={() => {
                if (button.onClick) button.onClick();
                onClose();
              }}
            >
              {button.label}
            </button>
          ))}
        </div>
      </div>
    ),
  });
}
